import { render, staticRenderFns } from "./GestionTurnosSemana.vue?vue&type=template&id=ada21898&scoped=true"
import script from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
export * from "./GestionTurnosSemana.vue?vue&type=script&lang=js"
import style0 from "./GestionTurnosSemana.vue?vue&type=style&index=0&id=ada21898&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada21898",
  null
  
)

export default component.exports